import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { Flex, IllustratedMessage, Typography } from '@percent/lemonade'
import { Layout } from '@percent/education-hosted-form/ui'
import { useTrackEvent } from '@percent/education-hosted-form/analytics/useTrackEvent'
import { getPartnerPublicKey } from '@percent/education-hosted-form/utils/getPartnerPublicKey'
import { storage } from '@percent/education-hosted-form/utils/storage'
import { InvalidLinkProps } from './InvalidLink.types'
import styles from './InvalidLink.module.scss'

export function InvalidLink({ screen, description, title, helpCenterUrl }: InvalidLinkProps) {
  const { t } = useTranslation()
  const trackEvent = useTrackEvent()

  // Report each error-screen view, attributed by the token's partnerPublicKey.
  useEffect(() => {
    const partnerPublicKey: string = getPartnerPublicKey(storage.getItem('jwtToken') ?? undefined) ?? ''

    trackEvent('education_form_error_screen_viewed', { screen, partnerPublicKey })
  }, [trackEvent, screen])

  const titleText = t(title) as string
  const descriptionText = t(description) as string

  return (
    <Layout>
      <Flex direction="column" align="center" gap={8} m="auto">
        <IllustratedMessage illustration="invalid-link" />
        <Typography variant="h2" className={styles.textStyles}>
          {titleText}
        </Typography>
        <Typography className={styles.textStyles}>
          {descriptionText}
          {helpCenterUrl && (
            <a
              href={helpCenterUrl}
              className={styles.helpCenterLink}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => trackEvent('education_form_button_clicked', { button: 'help_center', screen })}
            >
              {t('typography.helpCenter')}
            </a>
          )}
        </Typography>
      </Flex>
    </Layout>
  )
}
